import { ThemeImageElement, ThemeLinkElement } from '@nucleus/types/web';
import { WebImage, formatSrcSet } from '@nucleus/web-theme-elements';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

declare module '@nucleus/post-theme-elements' {
  interface PostThemeElementsTheme {
    CardImageElement?: {
      background?: string;
      borderRadius?: string;
      captionColor?: string;
      captionFontSize?: string;
      captionMarginTop?: string;
      captionPaddingLeft?: string;
      imageBorderRadius?: string;
      padding?: string;
    };
  }
}

interface CardImageElementProps {
  children?: React.ReactNode;
  node: ThemeImageElement & { link?: Partial<ThemeLinkElement> };
}

export const CardImageElement = ({ node }: CardImageElementProps): JSX.Element => {
  const imageContent = (
    <ImageContainer>
      <WebImage
        alt={node.alt}
        blurHash={node.blurHash}
        dimensions={node.dimensions}
        src={node.src}
        srcSet={formatSrcSet(node.srcSet)}
      />
    </ImageContainer>
  );

  const linkedImage =
    node.link?.href !== undefined && node.link?.href !== '' ? (
      <Link to={node.link.href} target={node.link.openInNewTab === true ? '_blank' : undefined}>
        {imageContent}
      </Link>
    ) : (
      imageContent
    );

  return (
    <CardContainer
      data-block-type="image"
      style={{ maxWidth: node.size !== undefined ? `${node.size}%` : undefined }}
    >
      {linkedImage}
      {node.caption !== undefined && node.caption !== '' && <Caption>{node.caption}</Caption>}
    </CardContainer>
  );
};

const CardContainer = styled.div`
  width: 100%;
  background: ${({ theme }) => theme._postThemeElements?.CardImageElement?.background ?? '#f2f2f2'};
  border-radius: ${({ theme }) => theme._postThemeElements?.CardImageElement?.borderRadius ?? '18px'};
  padding: ${({ theme }) => theme._postThemeElements?.CardImageElement?.padding ?? '24px 24px 20px 24px'};
`;

const ImageContainer = styled.div`
  border-radius: ${({ theme }) => theme._postThemeElements?.CardImageElement?.imageBorderRadius ?? '6px'};
  overflow: hidden;
`;

const Caption = styled.div`
  margin-top: ${({ theme }) => theme._postThemeElements?.CardImageElement?.captionMarginTop ?? '30px'};
  padding-left: ${({ theme }) => theme._postThemeElements?.CardImageElement?.captionPaddingLeft ?? '0'};
  font-size: ${({ theme }) => theme._postThemeElements?.CardImageElement?.captionFontSize ?? '18px'};
  font-weight: 100;
  color: ${({ theme }) => theme._postThemeElements?.CardImageElement?.captionColor ?? 'inherit'};
  letter-spacing: -0.35px;
  line-height: 18px;
`;
